module.exports = __webpack_public_path__ + "img/monitoring-dark.f4180709.svg";